// @generated by web/tools/codegen — DO NOT EDIT

/**
 * The CLOSED page-chrome vocabulary — generated from the `PageChrome`
 * enum webroutesgen parses `web/manifests/routes.yaml`'s `chrome:` with,
 * so the union and the manifest cannot disagree.
 *
 * - `hub`: a root destination: navbar, footer (md+), bottom tabs (<md)
 * - `article`: a content page that owns its bottom edge: navbar + footer, no tabs
 * - `focus`: the page owns its bottom edge: navbar only, no footer, no tabs
 * - `inbox`: a tab root that is not a content page: navbar + bottom tabs, no footer
 * - `flow`: no site chrome at all - the page owns the whole viewport
 *
 * `PageShell`'s table is `satisfies Record<PageChrome, ChromeSpec>`, so a
 * kind added to the manifest's vocabulary does not typecheck until the
 * shell says which bands it renders.
 */
export const PAGE_CHROME_KINDS = ['hub', 'article', 'focus', 'inbox', 'flow'] as const;

/** One of {@link PAGE_CHROME_KINDS}. */
export type PageChrome = (typeof PAGE_CHROME_KINDS)[number];

/**
 * Narrow a route match's `handle.chrome`. React Router types `handle`
 * as `unknown`, so the shell owns the narrowing — and a value outside
 * the vocabulary must THROW rather than default, because a default
 * renders some chrome for a route whose chrome nobody decided.
 */
export function isPageChrome(value: unknown): value is PageChrome {
  return (PAGE_CHROME_KINDS as readonly unknown[]).includes(value);
}
